import type { AdminAllStore } from '../../../types/features/adminAllStores';
import type { FeatureFlagStoreOption } from '../../../types/features/featureFlags';

const joinStoreAddress = (store: AdminAllStore): string | undefined => {
  const addressParts = [
    store.address_line1,
    store.city,
    store.state,
    store.postal_code,
  ].filter(Boolean);

  return addressParts.length > 0 ? addressParts.join(', ') : undefined;
};

export const mapAdminStoreToFeatureFlagStoreOption = (store: AdminAllStore): FeatureFlagStoreOption => ({
  address: joinStoreAddress(store),
  id: store.id,
  name: store.name || 'Unnamed Store',
  storeKey: store.store_key || undefined,
});

export const filterFeatureFlagStoreOptions = (
  stores: FeatureFlagStoreOption[],
  search: string,
): FeatureFlagStoreOption[] => {
  const normalizedSearch = search.trim().toLowerCase();

  if (!normalizedSearch) {
    return stores;
  }

  return stores.filter((store) => [
    store.name,
    store.address,
    store.storeKey,
    store.id,
  ].some((value) => String(value || '').toLowerCase().includes(normalizedSearch)));
};
